'use client';

// Read-only data hook for M2. Calls storage.listMembers() once
// and exposes { members, loading, error, refresh }. Write methods
// are added in M3.

import { useCallback, useEffect, useState } from "react";
import { useTeam } from "../internals";

export const useTeamData = (filters) => {
  const { storage } = useTeam();
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const list = await storage.listMembers(filters || {});
      setMembers(list);
    } catch (e) {
      setError(e?.message || "Couldn't load the team.");
    } finally {
      setLoading(false);
    }
  }, [storage, filters]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { members, loading, error, refresh };
};
